import { TdWebService } from '../service/TdWebService';
const useTd = () => {
    const setMemberId = (memberId) => {
        // @ts-ignore
        return TdWebService.setMemberId(memberId);
    };
    const search = (tdId, val, url) => {
        // @ts-ignore
        return TdWebService.search(tdId, val, url);
    };
    return {
        setMemberId,
        search,
    };
};
export default useTd;
